export default __webpack_public_path__ + "static/media/doctor7.a4b94b9f.jpg";